import { render } from "./CodigoParceiroExport.vue?vue&type=template&id=89f8b1b6"
import script from "./CodigoParceiroExport.vue?vue&type=script&lang=js"
export * from "./CodigoParceiroExport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__